var render = function (_h,_vm) {var _c=_vm._c;return _c('g',{attrs:{"transform":_vm.props.transform}},_vm._l((_vm.props.letter),function(item){return _c('g',{key:item.d},[_c('path',{class:item.class,attrs:{"d":item.d,"stroke-linecap":item.strokeLinecap}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }